export default __webpack_public_path__ + "static/media/slide13.2e7788cd.png";